import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SegmentoService } from 'src/app/service/segmento.service';
import { aplicarFiltrosConsulta } from 'src/app/util/consulta/wow-consulta.util';
import { Segmento } from './segmento';

@Component({
  selector: 'app-segmento-consulta',
  templateUrl: './segmento-consulta.component.html',
  styleUrls: [
    './segmento-shared.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class SegmentoConsultaComponent {

  segmentos: Segmento[] = [];
  tipoFiltros = ['ID', 'Código', 'Nome'];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;
  consultaRealizada = false;

  constructor(
    private service: SegmentoService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  consultar() {
    this.service.listar().subscribe(lista => {
      this.segmentos = aplicarFiltrosConsulta(lista ?? [], this.tipoFiltro, this.parametro, this.situacao, {
        id: s => s.id,
        nome: s => s.nome,
        codigo: s => s.codigo,
        ativo: s => s.ativo !== false,
      });
      this.consultaRealizada = true;
    }, () => this.snackBar.open('Erro ao listar segmentos.', 'ERRO', { duration: 2500 }));
  }

  novo() {
    this.router.navigate(['/segmento/form']);
  }

  editar(segmento: Segmento) {
    if (segmento.id) {
      this.router.navigate(['/segmento/form', segmento.id]);
    }
  }

  inativar(segmento: Segmento) {
    if (!segmento.id || !confirm('Inativar este segmento (sistema)?')) {
      return;
    }
    this.service.inativar(segmento.id).subscribe(() => {
      this.snackBar.open('Segmento inativado.', 'OK', { duration: 2000 });
      this.consultar();
    });
  }
}
